import { TextAnnotation } from '@st/sdk'
import { THEME_COLORS } from '@st/theme/colors'
import { TextToolState } from '../../annotations'

export const TEXT_COLOR_OPTIONS = [
  THEME_COLORS['red'][600],
  THEME_COLORS['blue'][500],
  THEME_COLORS['purple'][500],
  THEME_COLORS['orange'][500],
  THEME_COLORS['green'][500],
  THEME_COLORS['gray'][900]
]

export function copyToolState(annotation: TextAnnotation): TextToolState {
  return {
    name: 'text',
    settings: {
      color: annotation.color,
      font: annotation.font
    }
  }
}
